import script from "./AppSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSection.vue?vue&type=script&setup=true&lang=js"

import "./AppSection.vue?vue&type=style&index=0&id=d92390ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92390ce"]])

export default __exports__